import CustomList from '@/components/global/list/CustomList.jsx';
import { useEffect } from 'react';
import { useListContext, usePermissions, useTranslate } from 'react-admin';
import { AdsCampaingsActions } from '@/components/adsCampaings/AdsCampaingsActions.jsx';
import { AdsCampaignsGrid } from '@/components/adsCampaings/AdsCampaignsGrid.jsx';
import { AdsNotificationBox } from '@/components/adsCampaings/AdsNotificationBox.jsx';
import { AD_STATUS_FILTER_DEFAULT } from '@/constants/AdStatus.js';

const AdsCampaignsDataLogger = () => {
    const { error } = useListContext();

    useEffect(() => {
        if (error && import.meta.env?.DEV) {
            console.error('ads campaigns error:', error);
        }
    }, [error]);

    return null;
};

export const AdCampaings = () => {
    const { isLoading } = usePermissions();
    const translate = useTranslate();

    if (isLoading) return null;

    return (
        <CustomList
            title={translate('resources.campaign.labels.adsCampaigns')}
            filters={[]}
            filterDefaultValues={{ status_in: AD_STATUS_FILTER_DEFAULT }}
            actions={<AdsCampaingsActions />}
            sort={{ field: 'endDate', order: 'DESC' }}
            perPage={10}
            rowsPerPageOptions={[]}
            paginationClassName='pagination-rounded'
            empty={false}
        >
            <AdsCampaignsDataLogger />
            <AdsNotificationBox />
            <AdsCampaignsGrid />
        </CustomList>
    );
};
